import { AppState, useAppSelector } from '@redux/store';

export const useUserLikesCount = ({
  showId,
  userId,
}: {
  showId: string;
  userId?: string;
}) =>
  useAppSelector(({ likes }: AppState) => {
    if (!userId) {
      return 0;
    }
    const userLikes = likes.byShow?.[showId]?.byUser?.[userId];
    return userLikes?.count ?? 0;
  });

export const useUserLikeStatus = ({
  showId,
  userId,
}: {
  showId: string;
  userId?: string;
}) =>
  useAppSelector(({ likes }: AppState) => {
    if (!userId) {
      return false;
    }
    const userLikes = likes.byShow?.[showId]?.byUser?.[userId];
    return userLikes?.isLiked ?? false;
  });

export const useSpeakerLikesCount = ({
  showId,
  speakerId,
}: {
  showId: string;
  speakerId?: string | null;
}) =>
  useAppSelector(({ likes }: AppState) => {
    if (!speakerId) {
      return 0;
    }
    const speakerLikes = likes.byShow?.[showId]?.bySpeaker?.[speakerId];
    return speakerLikes?.count ?? 0;
  });

export const useSpeakerLikeStatus = ({
  showId,
  speakerId,
}: {
  showId: string;
  speakerId?: string | null;
}) =>
  useAppSelector(({ likes }: AppState) => {
    if (!speakerId) {
      return false;
    }
    const speakerLikes = likes.byShow?.[showId]?.bySpeaker?.[speakerId];
    return speakerLikes?.isLiked ?? false;
  });
